import React from 'react'

const CustomDateField = ({ property, name, record, ...props }) => {
  if (!record) return <span />
  return <span>{new Date(record[name]).toUTCString()}</span>
}

export default CustomDateField
